export default __webpack_public_path__ + "static/media/twitter.fa1f3818.svg";